export default () => ({
  rootContainer: {
    position: "relative",
    background: "#f9f9f9",
    flex: 1,
    minHeight: "calc(100vh - 131px)",//`calc(${window.innerHeight}px - 64px)`,
    padding: 30,
  },
  fieldContainer: {
    marginBottom: "12px"
  },
  subHeader: {
    fontSize: 14,
    color: "black",
    fontFamily: "Open Sans",
    width: 509,
    height: 20
  },
  footer: {
    fontSize: 14,
    color: "grey",
    fontFamily: "Open Sans",
    width: 602,
    height: 40,
    margin: "20px 0"
  },
  textField: {
    width: 250,
    height: 40,
    marginTop: 20
  },
  buttonContainer: {
    display: "flex",
    width: 660,
    justifyContent: "flex-end",
    marginTop: 20
  },
  cancelButton: {
    color: "Gray"
  },
  sendButton: {
    boxShadow: "none"
  },
  sentSuccess: {
    color: "#66D184",
    fontWeight: "bold",
    marginRight: 8,
    marginLeft: 12,
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
    width: "max-content"
  },
  testForm: {
    paddingBottom: 8
  },
  sendButtonStyle: {
    marginTop: 24,
    textTransform: "none",
    height: 40
  },
  disabledStyle: {
    pointerEvents: "none",
    opacity: 0.5
  },

})